import axios from 'axios';
import React, { useEffect, useState } from 'react'
import { useAlert } from 'react-alert';
import { Form, Container, Row, Modal, Button, FormSelect, ProgressBar, Alert } from 'react-bootstrap';
import api from '../../seller-apis/api';
import servicesApi from '../../seller-apis/servicesApi';
import { variables } from '../../Variables.json'
import './register.css';
import { GenUtilities } from '../../utilities/GenUtilities';
// Images related
var imagesName = [];
var s3Urls = [];
var gstFileName;
var tanFileName;
var panFileName;
var chequeFileName;
function Register2() {



    const alert = useAlert();

    // Input fields

    const [gstNo, setGstNo] = useState();
    const [mobile, setmobile] = useState(sessionStorage.getItem("reg_Mobile"));
    const [email, setemail] = useState(sessionStorage.getItem("reg_Mail"));
    const [mobileState, setmobileState] = useState("mobile");
    const [emailState, setemailState] = useState("email")
    const [vendorId, setvendorId] = useState();



    const [rName, setrName] = useState(sessionStorage.getItem("reg_CompanyName"));
    const [remail, setremail] = useState("");
    const [gaddress, setgaddress] = useState("");
    const [pickupaddress, setpickupaddress] = useState("");
    const [rphone, setrphone] = useState();
    const [gcity, setgcity] = useState();
    const [city, setcity] = useState();
    const [gzip, setgzip] = useState();
    const [zip, setzip] = useState();
    const [tanNo, setTanNo] = useState("");
    const [panNo, setPanNo] = useState("");

    const [gState, setgState] = useState();
    const [State, setState] = useState();
    const [glandmark, setglandmark] = useState();
    const [landmark, setlandmark] = useState();
    const [sameaddresscheck, setSameaddresscheck] = useState(false);

    // Otp input mobile
    const [first, setfirst] = useState();
    const [second, setsecond] = useState();
    const [third, setthird] = useState();
    const [fourth, setfourth] = useState();
    const [resendOtpDiv, setresendOtpDiv] = useState();

    // otp input email
    const [firstmail, setfirstmail] = useState();
    const [secondmail, setsecondmail] = useState();
    const [thirdmail, setthirdmail] = useState();
    const [fourthmail, setfourthmail] = useState();
    const [resendOtpDivMail, setresendOtpDivMail] = useState();



    // Bank Details

    const [bankAccountNo, setBankAccountNo] = useState()
    const [ifscCode, setIfscCode] = useState("")
    const [accountHolderName, setAccountHolderName] = useState("")
    const [cancelledCheque, setCancelledCheque] = useState("")
    const [chequeUploadProg, setChequeUploadProg] = useState("")
    // Images Related 
    const [urlList, seturlList] = useState([]);
    const [urlListshow, seturlListshow] = useState(false);
    const [imgprogress, setimgprogress] = useState()
    const [gstUploadProg, setgstUploadProg] = useState()
    const [tanUploadProg, settanUploadProg] = useState()
    const [panUploadProg, setpanUploadProg] = useState()

    // Alert related states

    const [modalShow, setModalShow] = useState(false);

    // Remove files related

    const [showtanFileRemove, setshowtanFileRemove] = useState(false)

    useEffect(() => {
        setGstNo(localStorage.getItem("gst"));
        setvendorId(localStorage.getItem("vendorId"))
        gstFileName = ""
        tanFileName = ""
        panFileName = ""
        chequeFileName = ""
    }, [])



    // Show Image

    function showImage(event) {
        seturlListshow(false)

        let comImg;
        let imageFinal;
        let registerImage;
        let isimgsSizevalid = true
        let limit = event.target.files.length;
        console.log(event.target.files.length)
        if (event.target.files.length > 2) {
            limit = 2 - urlList.length;
        }
        for (let i = 0; i < limit; i++) {
            if (event.target.files[i].size > variables.limit.RegisterVendor.storePhoto) {
                isimgsSizevalid = false
            }
        }
        if (isimgsSizevalid) {
            seturlListshow(false)
            for (let i = 0; i < limit; i++) {
                console.log(i)
                var str = event.target.files[i].name;
                // let extension = event.target.files[i].name.slice(event.target.files[i].name.lastIndexOf("."));
                const extension = GenUtilities.profileMimeExtensions[event.target.files[i].type] || "";
                comImg = str.replace(0, str.lastIndexOf("."))
                imageFinal = GenUtilities.removeSpacesFromName("img_" + vendorId + "_" + comImg);
                registerImage = event.target.files[0];
                imagesName.push(imageFinal)
                var data = {
                    "imageName": imageFinal,
                    "type": "products",
                    "bucket": "seller_doc"
                }
                servicesApi.saveImage(data).then((res) => {
                    axios({
                        method: 'put',
                        url: res.data,
                        data: registerImage,
                        onUploadProgress: data => {
                            //Set the progress value to show the progress bar
                            setimgprogress(Math.round((100 * data.loaded) / data.total))
                        },
                    })
                        .then(response => {
                            setimgprogress()
                            seturlList(imagesName)
                            seturlListshow(true)
                        })
                        .catch(error => {
                            console.log(error);
                        });
                }).catch((err) => console.log(err))
                s3Urls.push(imageFinal)

            }
        }
        else {
            alert.info("Please upload images of size less than or equal to 2 Mb")
        }
    }

    // function uploadCheque

    function uploadCheque(event) {
        let comImg;
        let imageFinal;
        let registerImage;
        let filesSize = 0;
        let limit = event.target.files.length;
        for (let i = 0; i < limit; i++) {
            filesSize = filesSize + event.target.files[i].size
        }
        if (filesSize <= variables.limit.RegisterVendor.gstSize) {
            for (let i = 0; i < 1; i++) {
                console.log(i)
                var str = event.target.files[i].name;
                // let extension = event.target.files[i].name.slice(event.target.files[i].name.lastIndexOf("."));
                const extension = GenUtilities.profileMimeExtensions[event.target.files[i].type] || "";
                comImg = str.replace(0, str.lastIndexOf("."))
                imageFinal = GenUtilities.removeSpacesFromName("CancelledCheque_" + vendorId + "_" + comImg);
                registerImage = event.target.files[0];
                chequeFileName = imageFinal;
                // seller document not able to download SL-1206 --docket name and type was not set
                var data = {
                    imageName: imageFinal,
                    type: "products",
                    bucket: "seller_doc"
                }
                servicesApi.saveImage(data).then((res) => {
                    axios({
                        method: 'put',
                        url: res.data,
                        data: registerImage,
                        onUploadProgress: data => {
                            //Set the progress value to show the progress bar
                            setChequeUploadProg(Math.round((100 * data.loaded) / data.total))
                        },
                    })
                        .then(response => {
                            setChequeUploadProg()
                        })
                        .catch(error => {
                            console.log(error);
                        });
                }).catch((err) => console.log(err))
            }
        }
        else {
            document.getElementById("chequeInput").value = ""
            alert.info("File size can be upto 2 Mb max.")
        }
    }


    // Upload gst file


    function uploadGst(event) {
        let comImg;
        let imageFinal;
        let registerImage;
        let filesSize = 0;
        let limit = event.target.files.length;
        for (let i = 0; i < limit; i++) {
            filesSize = filesSize + event.target.files[i].size
        }
        if (filesSize <= variables.limit.RegisterVendor.gstSize) {
            for (let i = 0; i < 1; i++) {
                console.log(i)
                var str = event.target.files[i].name;
                // let extension = event.target.files[i].name.slice(event.target.files[i].name.lastIndexOf("."));
                const extension = GenUtilities.profileMimeExtensions[event.target.files[i].type] || "";
                comImg = str.replace(0, str.lastIndexOf("."))
                imageFinal = GenUtilities.removeSpacesFromName("gst_" + vendorId + "_" + comImg);
                registerImage = event.target.files[0];
                gstFileName = imageFinal;
                var data = {
                    "imageName": imageFinal,
                    "type": "products",
                    "bucket": "seller_doc"
                }
                servicesApi.saveImage(data).then((res) => {
                    axios({
                        method: 'put',
                        url: res.data,
                        data: registerImage,
                        onUploadProgress: data => {
                            //Set the progress value to show the progress bar
                            setgstUploadProg(Math.round((100 * data.loaded) / data.total))
                        },
                    })
                        .then(response => {
                            setgstUploadProg()
                            console.log(response)
                        })
                        .catch(error => {
                            console.log(error);
                        });
                }).catch((err) => console.log(err))

                console.log(gstFileName)
            }
        }
        else {
            document.getElementById("gstInput").value = ""
            alert.info("File size can be upto 2 Mb max.")
        }
    }


    // Upload tan file


    function uploadTan(event) {
        let comImg;
        let imageFinal;
        let registerImage;
        let limit = event.target.files.length;
        let filesSize = 0;
        for (let i = 0; i < limit; i++) {
            filesSize = filesSize + event.target.files[i].size
        }
        if (filesSize <= variables.limit.RegisterVendor.tanSize) {
            for (let i = 0; i < 1; i++) {
                console.log(i)
                var str = event.target.files[i].name;
                // let extension = event.target.files[i].name.slice(event.target.files[i].name.lastIndexOf("."));
                const extension = GenUtilities.profileMimeExtensions[event.target.files[i].type] || "";
                console.log(str.lastIndexOf("."))
                comImg = str.replace(0, str.lastIndexOf("."))
                console.log(comImg)
                imageFinal = GenUtilities.removeSpacesFromName("tan_" + vendorId + "_" + comImg);
                registerImage = event.target.files[0];
                tanFileName = imageFinal;
                var data = {
                    "imageName": imageFinal,
                    "type": "products",
                    "bucket": "seller_doc"
                }
                servicesApi.saveImage(data).then((res) => {
                    axios({
                        method: 'put',
                        url: res.data,
                        data: registerImage,
                        onUploadProgress: data => {
                            //Set the progress value to show the progress bar
                            settanUploadProg(Math.round((100 * data.loaded) / data.total))
                        },
                    })
                        .then(response => {
                            settanUploadProg()
                            setshowtanFileRemove(true)
                            console.log(response)
                        })
                        .catch(error => {
                            console.log(error);
                        });
                }).catch((err) => console.log(err))

                console.log(tanFileName)
            }
        }
        else {
            document.getElementById("tanInput").value = ""
            alert.info("File size can be upto 2 Mb max.")
        }
    }


    // Upload pan file


    function uploadPan(event) {
        let comImg;
        let imageFinal;
        let registerImage;
        let limit = event.target.files.length;
        let filesSize = 0;
        for (let i = 0; i < limit; i++) {
            filesSize = filesSize + event.target.files[i].size
        }
        if (filesSize <= variables.limit.RegisterVendor.panSize) {
            for (let i = 0; i < 1; i++) {
                console.log(i)
                var str = event.target.files[i].name;
                // let extension = event.target.files[i].name.slice(event.target.files[i].name.lastIndexOf("."));
                const extension = GenUtilities.profileMimeExtensions[event.target.files[i].type] || "";
                console.log(str.lastIndexOf("."))
                comImg = str.replace(0, str.lastIndexOf("."))
                console.log(comImg)
                imageFinal = GenUtilities.removeSpacesFromName("pan_" + vendorId + "_" + comImg);
                registerImage = event.target.files[0];
                panFileName = imageFinal;
                var data = {
                    "imageName": imageFinal,
                    "type": "products",
                    "bucket": "seller_doc"
                }
                servicesApi.saveImage(data).then((res) => {
                    axios({
                        method: 'put',
                        url: res.data,
                        data: registerImage,
                        onUploadProgress: data => {
                            //Set the progress value to show the progress bar
                            setpanUploadProg(Math.round((100 * data.loaded) / data.total))
                        },
                    })
                        .then(response => {
                            setpanUploadProg()
                            console.log(response)
                        })
                        .catch(error => {
                            console.log(error);
                        });
                }).catch((err) => console.log(err))

                console.log(tanFileName)
            }
        }
        else {
            document.getElementById("panInput").value = ""
            alert.info("File size can be upto 2 Mb max.")
        }
    }

    // Delete image

    function deleteImg(index) {
        seturlListshow(false)
        seturlList([]);

        imagesName.splice(index, 1);
        let eleLoader = document.getElementById("loader-Img-upload");

        seturlList(imagesName)

        eleLoader.setAttribute('class', ' text-info');

        setTimeout(() => {

            eleLoader.removeAttribute('class');

            seturlListshow(true)
        }, 1000);
    }


    // Same address as office address

    function funcSameAddress(e) {
        if (e) {
            setSameaddresscheck(true)
            setlandmark(glandmark)
            setcity(gcity)
            setzip(gzip)
            setState(gState)
            setpickupaddress(gaddress)
        }
        else {
            setlandmark("")
            setcity("")
            setzip("")
            setState("")
            setpickupaddress("")
            setSameaddresscheck(false)
        }
    }

    // Input otp

    function inputotp(e, no) {
        console.log(e)
        let btns = document.getElementsByClassName("form-control-val");

        if (e.keyCode === 8) {
            if (no > 0) {
                console.log("dnjk")
                btns[no].value = ""
                btns[no].disabled = false;
                btns[no - 1].disabled = false
                btns[no - 1].focus();

            }
            else {
                btns[no].disabled = false;
                btns[no].value = ""
                btns[no].focus()
            }
        }
        else if ((e.keyCode >= 48 && e.keyCode <= 57) || (e.keyCode >= 96 && e.keyCode <= 105)) {
            console.log(typeof (btns[no].value))
            if (no < 3) {
                btns[no + 1].disabled = false;
                btns[no].disabled = true
                btns[no + 1].focus()
            }
            else {
                //  btns[no].disabled = true;
                btns[no].focus()
                btns[no].select()
            }
        }
    }


    // Input otp mail

    function inputotmail(e, no) {
        let btns = document.getElementsByClassName("form-control-mail");

        if (e.keyCode === 8) {
            if (no > 0) {
                console.log("dnjk")
                btns[no].value = ""
                btns[no].disabled = false;
                btns[no - 1].disabled = false
                btns[no - 1].focus();

            }
            else {
                btns[no].disabled = false;
                btns[no].value = ""
                btns[no].focus()
            }
        }
        else if ((e.keyCode >= 48 && e.keyCode <= 57) || (e.keyCode >= 96 && e.keyCode <= 105)) {
            console.log(typeof (btns[no].value))
            if (no < 3) {
                btns[no + 1].disabled = false;
                btns[no].disabled = true
                btns[no + 1].focus()
            }
            else {
                //  btns[no].disabled = true;
                btns[no].focus()
                btns[no].select()
            }
        }
    }

    function handleInput(e, num) {
        if (isNaN(e)) {
            if (num === 0) {
                setfirst(first)
            }
            else if (num === 1) {
                setsecond(second)
            }
            else if (num === 2) {
                setthird(third)
            }
            else if (num === 3) {
                setfourth(fourth)
            }
        }
        else {
            if (e > 9) {
                if (num === 0) {
                    setfirst(first)
                }
                else if (num === 1) {
                    setsecond(second)
                }
                else if (num === 2) {
                    setthird(third)
                }
                else if (num === 3) {
                    setfourth(fourth)
                }
            }
            else {
                if (num === 0) {
                    setfirst(e)
                }
                else if (num === 1) {
                    setsecond(e)
                }
                else if (num === 2) {
                    setthird(e)
                }
                else if (num === 3) {
                    setfourth(e)
                }
            }
        }

    }

    // Handle input mail

    function handleInputMail(e, num) {
        if (isNaN(e)) {
            if (num === 0) {
                setfirstmail(firstmail)
            }
            else if (num === 1) {
                setsecondmail(secondmail)
            }
            else if (num === 2) {
                setthirdmail(thirdmail)
            }
            else if (num === 3) {
                setfourthmail(fourthmail)
            }
        }
        else {
            if (e > 9) {
                if (num === 0) {
                    setfirstmail(firstmail)
                }
                else if (num === 1) {
                    setsecondmail(secondmail)
                }
                else if (num === 2) {
                    setthirdmail(thirdmail)
                }
                else if (num === 3) {
                    setfourthmail(fourthmail)
                }
            }
            else {
                if (num === 0) {
                    setfirstmail(e)
                }
                else if (num === 1) {
                    setsecondmail(e)
                }
                else if (num === 2) {
                    setthirdmail(e)
                }
                else if (num === 3) {
                    setfourthmail(e)
                }
            }
        }
    }


    //   Send otp mobile func

    function sendOtp(payload, time) {
        if (payload === "mobile") {
            if (mobile === "" || mobile === undefined || mobile.length != 10) {
                alert.info("Please enter a valid mobile number")
            }
            else {
                let data = {
                    "field": "phoneNumber",
                    "_id": vendorId,
                    "value": mobile
                }
                api.auth.verifyField(data).then((res) => {
                    console.log(res)
                    if (res.message === "OTP sent") {
                        // setotpSent(true)
                        alert.show('OTP sent', {
                            type: 'success'
                        })
                        // resendOtp(time)
                        setmobileState("mobileOtp")
                    }
                    else {
                        setmobileState("mobile")
                        setModalShow(true)
                    }
                })
            }
        }
        else {
            if (email === "" || email === undefined || !email.includes("@")) {
                alert.info("Please enter a valid email address")
            }
            else {
                let data = {
                    "field": "email",
                    "value": email,
                    "_id": vendorId
                }

                api.auth.verifyField(data).then((res) => {
                    console.log(res)
                    if (res.message === "OTP sent") {
                        // setotpSent(true)
                        alert.show('Otp sent', {
                            type: 'success'
                        })
                        setemailState("emailOtp")
                        // resendOtpMail(time)
                    }
                    else {
                        setemailState("email")
                        alert.show(res.message, {
                            type: 'info'
                        })
                    }
                })
            }
        }


    }

    // Verify otp mobile

    const verifyOtp = () => {
        let otp = first + second + third + fourth
        console.log(first, fourth)

        if (first === "" || first === undefined || second === "" || second === undefined || third === "" || third === undefined || fourth === "" || fourth === undefined) {
            alert.info("Please enter the Otp")
        }
        else {
            let data = {
                "field": "phoneNumber",
                "_id": vendorId,
                "value": mobile,
                "otp": otp
            }

            api.auth.verifyField(data)
                .then((res) => {
                    console.log(res)
                    if (res.message === "phoneNumber verified") {
                        // setotpstatus("block")

                        alert.success("Phone verified")
                        setmobileState("verified")

                    } else if (res.message === "incorrect OTP") {
                        alert.show("Please enter correct Otp", {
                            type: 'error'
                        })
                    }
                    else {
                        alert.info("Error")
                    }
                })
                .catch(err => console.log(err))
        }

    }


    // Verify email otp

    function verifyMailOtp() {
        let emailotp = firstmail + secondmail + thirdmail + fourthmail
        console.log(firstmail, fourthmail)

        if (firstmail === "" || firstmail === undefined || secondmail === "" || secondmail === undefined || thirdmail === "" || thirdmail === undefined || fourthmail === "" || fourthmail === undefined) {
            alert.info("Please enter the Otp")
        }
        else {
            let data = {
                "value": email,
                "field": "email",
                "_id": vendorId,
                "otp": emailotp
            }
            api.auth.verifyField(data)
                .then((res) => {
                    console.log(res)
                    if (res.message === "email verified") {
                        alert.success("Email verified")
                        setemailState("email verified")
                    }
                    else if (res.message === "incorrect OTP") {
                        alert.show("Please enter correct Otp", {
                            type: 'error'
                        })
                    }
                    else {
                        alert.info("Error")
                    }
                })
                .catch(err => console.log(err))
        }

    }

    // Edit mobile number

    function editmobile() {
        setfirst()
        setsecond()
        setthird()
        setfourth();
        setmobileState("mobile")
    }

    // Edit email

    function editmail() {
        console.log("kdenkj")
        setfirstmail()
        setsecondmail()
        setthirdmail()
        setfourthmail()
        setemailState("email")
    }



    // Edit gst 

    function editgst() {
        window.location.assign('/register')
    }

    // Pincode apis

    function callPincode(e, spcl) {
        axios.get(`https://api.postalpincode.in/pincode/${e}`).then(res => res.data[0]).then(res => {
            if (res.PostOffice.length > 0) {
                if (spcl === "gzip") {
                    setgState(res.PostOffice[0].State)
                }
                else {
                    setState(res.PostOffice[0].State)
                }
            }
        }).catch(err => console.log(err))
    }


    function registerSeller() {
        const zipRegex = new RegExp("^[1-9]{1}[0-9]{2}[0-9]{3}$");
        const valiPan = /[A-Z]{5}[0-9]{4}[A-Z]{1}$/;
        let registrationdata = {}

        if (rName === undefined || rName === "") {
            alert.show("Please enter name", {
                type: 'info'
            })
        }
        else if (gaddress === undefined || gaddress === "") {
            alert.show("Please enter your office address", {
                type: 'info'
            })
        }

        else if (gzip === undefined || gzip === "" || !zipRegex.test(gzip)) {
            alert.show("Please enter a valid zip/postal code", {
                type: 'info'
            })
        }

        else if (gcity === undefined || gcity === "") {
            alert.show("Please enter your city", {
                type: 'info'
            })
        }


        else if (gState === undefined || gState === "") {
            alert.show("Please choose your state", {
                type: 'info'
            })
        }
        else if (pickupaddress === undefined || pickupaddress === "") {
            alert.show("Please enter your pickup address", {
                type: 'info'
            })
        }
        else if (city === undefined || city === "") {
            alert.show("Please enter your city", {
                type: 'info'
            })
        }

        else if (zip === undefined || zip === "" || !zipRegex.test(zip)) {
            alert.show("Please enter a valid zip/postal code", {
                type: 'info'
            })
        }

        else if (State === undefined || State === "") {
            alert.show("Please choose your state", {
                type: 'info'
            })
        }
        else if (bankAccountNo === "" || bankAccountNo === undefined) {
            alert.show("Please enter your bank account number", {
                type: 'info'
            })
        }
        else if (ifscCode === "" || ifscCode === undefined) {
            alert.show("Please enter your bank's IFSC code", {
                type: 'info'
            })
        }
        else if (accountHolderName === "" || accountHolderName === undefined) {
            alert.show("Please enter your account name as registered in your bank account", {
                type: 'info'
            })
        }
        else if (chequeFileName === "" || chequeFileName === undefined) {
            alert.show("Please upload a valid cancelled cheque", {
                type: 'info'
            })
        }
        else if (mobileState !== "verified") {
            alert.show("Please verify your mobile number", {
                type: 'info'
            })
        }
        else if (emailState !== "email verified") {
            alert.show("Please verify your email address", {
                type: 'info'
            })
        }

        else if (gstNo === undefined || gstNo === "") {
            alert.show("Please enter your GST no.", {
                type: 'info'
            })
        }

        else if ((tanNo === "" && tanFileName !== "") || (tanNo !== "" && tanFileName === "") || (tanFileName !== "" && tanNo !== "" && tanNo.length !== 10)) {
            alert.show("Please enter a valid TAN no and document", {
                type: 'info'
            })
        }
        else if (panNo === undefined || panNo === "" || panNo.length !== 10 || !valiPan.test(panNo.toUpperCase())) {
            alert.show("Please enter a valid PAN no.", {
                type: 'info'
            })
        }
        else if (panFileName === "" || panFileName === undefined) {
            alert.show("Please upload Pan file.", {
                type: 'info'
            })
        }
        else if (imagesName.length < 1) {
            alert.show("Please upload the images.", {
                type: 'info'
            })
        }
        else if (gstFileName === "" || gstFileName === undefined) {
            alert.show("Please upload Gst file.", {
                type: 'info'
            })
        }


        else {

            if (tanNo !== "" && tanNo !== undefined && tanFileName !== "" && tanFileName !== undefined) {
                registrationdata.tanVerified = {
                    "status": "PENDING",
                    "verifiedBy": ""
                }
                registrationdata.tanNo = tanNo.toUpperCase()
                registrationdata.tanFile = tanFileName
            }



            let gadres = {
                "city": gcity,
                "state": gState,
                "landmark": glandmark,
                "zipcode": gzip,
                "address": gaddress
            }

            registrationdata = {
                ...registrationdata,
                "_id": vendorId,
                "name": rName,
                "email": email,
                "phoneNumber": mobile,
                "gstVerified": {
                    "status": "PENDING",
                    "verifiedBy": ""
                },

                "panVerified": {
                    "status": "PENDING",
                    "verifiedBy": ""
                },
                "bankDetail": {
                    "acno": bankAccountNo,
                    "name": accountHolderName,
                    "ifsc": ifscCode,
                    "cancelledCheque": chequeFileName
                },
                "gAddress": gadres,
                "gstNo": gstNo,
                "businessCard": urlList,
                "city": city,
                "panNo": panNo.toUpperCase(),
                "panFile": panFileName,
                "state": State,
                "landmark": landmark,
                "zipcode": zip,
                "address": pickupaddress,
                "gstFile": gstFileName

            }



            api.auth.registerSeller(registrationdata)
                .then((res) => {
                    console.log(res)
                    if (res.data.message === "vendor updated") {
                        localStorage.setItem("token", res.data.token)
                        alert.success("Step completed")
                        window.location.assign('/register/3')
                    }
                    else {
                        alert.info("Error")
                    }
                }).catch((err) => {

                    console.log(err)
                })
        }
    }


    // Resend otp

    // function resendOtp(time){
    //     if(time && time >1){
    //         let elem = document.getElementById('OtpTimer');
    //         elem.style.display = "block"
    //     }
    //     setresendOtpDiv("none")
    //     let timerId = setInterval(countdown, 1000);
    // 	let timeLeft = 30;

    // 	function countdown() {
    //         let elem = document.getElementById('OtpTimer');
    // 		if (timeLeft === 0) {
    // 			clearTimeout(timerId);
    // 			elem.style.display = "none"
    // 			setresendOtpDiv("block")

    // 		} else {
    // 			timeLeft--;
    // 			elem.innerHTML = timeLeft;
    // 		}
    // 	}
    // }

    // Resen otp mail

    //   function resendOtpMail(time){
    //     if(time && time >1){
    //         let elem = document.getElementById('OtpTimerMail');
    //         elem.style.display = "block"
    //     }
    //     setresendOtpDivMail("none")
    //     let timerId = setInterval(countdownMail, 1000);
    // 	let timeLeft = 30;

    // 	function countdownMail() {
    //         let elem = document.getElementById('OtpTimerMail');
    // 		if (timeLeft === 0) {
    // 			clearTimeout(timerId);
    // 			elem.style.display = "none"
    // 			setresendOtpDivMail("block")

    // 		} else {
    // 			timeLeft--;
    // 			elem.innerHTML = timeLeft;
    // 		}
    // 	}
    // }


    // Remove uploaded file

    function removeFile(spcl) {
        switch (spcl) {
            case "TAN":
                console.log("djh")
                let ele = document.getElementById("tanfileinput")
                ele.value = ""
                tanFileName = ""
                alert.info("File Removed")
                setshowtanFileRemove(false)
        }
    }


    return (
        <div className='form-register'>
            <div className='text-center p-2'><img src='/seller-test.png' className='w-15'></img></div>

            <div className='text-white bg-theme text-center  fs-16 py-1 '>
                REGISTRATION FORM
            </div>

            <Container>
                <div className='text-center'>
                    <h4 className='mt-3'>Step 1</h4>
                    <p>
                        <span className='theme-col fs-15 mx-1 px-3 f-700'>{gstNo}</span>
                        <i className='fa fa-edit theme-col fs-19' onClick={() => editgst()}></i> Edit
                    </p>

                </div>
                <div className='form-register__theme-shed1 p-2 mt-2 '>

                    <div className="form-register__input-cont">
                        <input type="text" name="text" value={rName} onChange={(e) => setrName(e.target.value)} required />
                        <label for="name" className="label-name  ">
                            <span className="content-name in-col pl-1">
                                Name: </span>
                        </label>
                    </div>
                </div>

                {/* Add gst address or office address */}
                <form className='form-register__theme-shed1 pb-2'>
                    <Row className='mt-2'>
                        <div className='col-12'>
                            <div className=' p-2 mt-2'>
                                <span className='f-700 form-register__label'> Add Office Address :</span><br></br>


                                <div className="form-register__input-cont">
                                    <input type="text" name="text" onChange={(e) => setgaddress(e.target.value)} required />
                                    <label for="name" className="label-name ">
                                        <span className="content-name in-col ">
                                            Address *(Street, Apartment, Area Near, etc): </span>
                                    </label>
                                </div>
                            </div></div>

                        <div className="col-6">
                            <div className="form-register__input-cont">
                                <input type="text" name="text" onChange={(e) => setglandmark(e.target.value)} required />
                                <label for="name" className="label-name ">
                                    <span className="content-name in-col pl-1">
                                        Landmark: </span>
                                </label>
                            </div>

                        </div>

                        <div className="col-6">
                            <div className="form-register__input-cont">
                                <input type="number" name="text" onChange={(e) => {
                                    if (e.target.value.length < 7) {
                                        setgzip(e.target.value)
                                        if (e.target.value.length === 6) {
                                            callPincode(e.target.value, "gzip")
                                        }
                                    }
                                }} value={gzip} onWheel={(e) => e.target.blur()} required />
                                <label for="name" className="label-name ">
                                    <span className="content-name in-col">
                                        Zip/postal Code* </span>
                                </label>
                            </div>

                        </div>

                        <div className="col-6">
                            <div className="form-register__input-cont">
                                <input type="text" name="text" onChange={(e) => setgcity(e.target.value)} required />
                                <label for="name" className="label-name ">
                                    <span className="content-name in-col pl-1">
                                        City * </span>
                                </label>
                            </div>

                        </div>
                        <div className='col-6'>
                            <div className=' p-2 mt-2'>

                                {/* <input type='text'  placeholder='State*' className=' w-100 place-h place-back'>

</input> */}
                                <select onChange={(e) => setgState(e.target.value)} required className=' w-100 register-form__place-h register-form__place-back ' value={gState}>

                                    <option value="" disabled selected>State*</option>
                                    <option value="Andaman and Nicobar Islands">Andaman and Nicobar Islands</option>
                                    <option value="Andhra Pradesh"> Andhra Pradesh</option>
                                    <option value="Arunachal Pradesh">Arunachal Pradesh</option>
                                    <option value="Assam">Assam</option>
                                    <option value="Bihar">Bihar</option>
                                    <option value="Chandigarh">Chandigarh</option>
                                    <option value="Chhattisgarh">Chhattisgarh</option>
                                    <option value="Dadra and Nagar Haveli andDaman and Diu">Dadra and Nagar Haveli and
                                        Daman & Diu</option>
                                    <option value="Delhi">Delhi</option>
                                    <option value="Goa">Goa</option>
                                    <option value="Gujarat">Gujarat</option>
                                    <option value="Haryana">Haryana</option>
                                    <option value="Himachal Pradesh">Himachal Pradesh</option>
                                    <option value="JammuKashmir">Jammu & Kashmir</option>
                                    <option value="Jharkhand">Jharkhand</option>
                                    <option value="Karnataka">Karnataka</option>
                                    <option value="Kerela">Kerela</option>
                                    <option value="Ladakh">Ladakh</option>
                                    <option value="Lakshadweep">Lakshadweep</option>
                                    <option value="Madhya Pradesh">Madhya Pradesh</option>
                                    <option value="Maharashtra">Maharashtra</option>
                                    <option value="Manipur"> Manipur</option>
                                    <option value="Meghalaya">Meghalaya</option>
                                    <option value="Mizoram">Mizoram</option>
                                    <option value="Nagaland">Nagaland</option>
                                    <option value="Orissa">Orissa</option>
                                    <option value="Punjab">Punjab</option>
                                    <option value="Puducherry">Puducherry</option>
                                    <option value="Rajasthan">Rajasthan</option>
                                    <option value="Sikkim">Sikkim</option>
                                    <option value="Tamil Nadu">Tamil Nadu</option>
                                    <option value="Telangana">Telangana</option>
                                    <option value="Tripura">Tripura</option>
                                    <option value="Uttar Pradesh">Uttar Pradesh</option>
                                    <option value="Uttarakhand">Uttarakhand</option>
                                    <option value="West Bengal">West Bengal</option>
                                </select>
                            </div></div>
                    </Row>

                </form>


                {/* Add pickup address */}
                <form className='form-register__theme-shed1 pb-2'>
                    <Row className='mt-2'>
                        <div className='col-12'>
                            <div className=' p-2 mt-2'>
                                <Form.Check className='f-700 text-primary mb-2' checked={sameaddresscheck} onChange={(e) => funcSameAddress(e.target.checked)} label="Same as office address" />
                                <span className='f-700 form-register__label'> Add Pickup Address :</span><br></br>


                                <div className="form-register__input-cont">
                                    <input type="text" name="text" value={pickupaddress} onChange={(e) => setpickupaddress(e.target.value)} required />
                                    <label for="name" className="label-name ">
                                        <span className="content-name in-col ">
                                            Address *(Street, Apartment, Area Near, etc): </span>
                                    </label>
                                </div>
                            </div></div>

                        <div className="col-6">
                            <div className="form-register__input-cont">
                                <input type="text" name="text" value={landmark} onChange={(e) => setlandmark(e.target.value)} required />
                                <label for="name" className="label-name ">
                                    <span className="content-name in-col pl-1">
                                        Landmark: </span>
                                </label>
                            </div>

                        </div>

                        <div className="col-6">
                            <div className="form-register__input-cont">
                                <input type="number" name="text" value={zip} onChange={(e) => {
                                    if (e.target.value.length < 7) {
                                        setzip(e.target.value)
                                        if (e.target.value.length === 6) {
                                            callPincode(e.target.value, "zip")
                                        }
                                    }
                                }} onWheel={(e) => e.target.blur()} required />
                                <label for="name" className="label-name ">
                                    <span className="content-name in-col">
                                        Zip/postal Code* </span>
                                </label>
                            </div>

                        </div>

                        <div className="col-6">
                            <div className="form-register__input-cont">
                                <input type="text" name="text" value={city} onChange={(e) => setcity(e.target.value)} required />
                                <label for="name" className="label-name ">
                                    <span className="content-name in-col pl-1">
                                        City * </span>
                                </label>
                            </div>

                        </div>
                        <div className='col-6'>
                            <div className=' p-2 mt-2'>

                                {/* <input type='text'  placeholder='State*' className=' w-100 place-h place-back'>

</input> */}
                                <select value={State} onChange={(e) => setState(e.target.value)} required className=' w-100 register-form__place-h register-form__place-back '>
                                    <option value="" disabled selected>State*</option>
                                    <option value="Andaman and Nicobar Islands">Andaman and Nicobar Islands</option>
                                    <option value="Andhra Pradesh"> Andhra Pradesh</option>
                                    <option value="Arunachal Pradesh">Arunachal Pradesh</option>
                                    <option value="Assam">Assam</option>
                                    <option value="Bihar">Bihar</option>
                                    <option value="Chandigarh">Chandigarh</option>
                                    <option value="Chhattisgarh">Chhattisgarh</option>
                                    <option value="Dadra and Nagar Haveli andDaman and Diu">Dadra and Nagar Haveli and
                                        Daman & Diu</option>
                                    <option value="Delhi">Delhi</option>
                                    <option value="Goa">Goa</option>
                                    <option value="Gujarat">Gujarat</option>
                                    <option value="Haryana">Haryana</option>
                                    <option value="Himachal Pradesh">Himachal Pradesh</option>
                                    <option value="JammuKashmir">Jammu & Kashmir</option>
                                    <option value="Jharkhand">Jharkhand</option>
                                    <option value="Karnataka">Karnataka</option>
                                    <option value="Kerela">Kerela</option>
                                    <option value="Ladakh">Ladakh</option>
                                    <option value="Lakshadweep">Lakshadweep</option>
                                    <option value="Madhya Pradesh">Madhya Pradesh</option>
                                    <option value="Maharashtra">Maharashtra</option>
                                    <option value="Manipur"> Manipur</option>
                                    <option value="Meghalaya">Meghalaya</option>
                                    <option value="Mizoram">Mizoram</option>
                                    <option value="Nagaland">Nagaland</option>
                                    <option value="Orissa">Orissa</option>
                                    <option value="Punjab">Punjab</option>
                                    <option value="Puducherry">Puducherry</option>
                                    <option value="Rajasthan">Rajasthan</option>
                                    <option value="Sikkim">Sikkim</option>
                                    <option value="Tamil Nadu">Tamil Nadu</option>
                                    <option value="Telangana">Telangana</option>
                                    <option value="Tripura">Tripura</option>
                                    <option value="Uttar Pradesh">Uttar Pradesh</option>
                                    <option value="Uttarakhand">Uttarakhand</option>
                                    <option value="West Bengal">West Bengal</option>
                                </select>
                            </div></div>
                    </Row>

                </form>


                {/* Bank details */}

                <div className='form-register__theme-shed1 p-2 mt-2 '>
                    <span className='f-700 form-register__label'>Bank Details<span className='  text-danger'>*</span>:</span><br></br>

                    Account No* : <input type='number' value={bankAccountNo} className='theme-line corner py-1 w-25 me-3' onChange={(e) => {
                        setBankAccountNo(e.target.value)
                    }} onWheel={(e) => e.target.blur()} onKeyDown={(e) => {
                        if (e.key === "e") {
                            e.preventDefault();
                        }
                    }}>
                    </input>
                    IFSC Code* : <input type='text' value={ifscCode} onChange={(e) => setIfscCode(e.target.value)} className='theme-line corner py-1 w-25' onWheel={(e) => e.target.blur()}>
                    </input>
                    <br></br>
                    <br></br>
                    A/c Holder Name* : <input type='text' value={accountHolderName} onChange={(e) => setAccountHolderName(e.target.value)} className='theme-line corner py-1 w-25 me-3' onWheel={(e) => e.target.blur()}>
                    </input>
                    {/* IFSC Code* :     <div className=''> */}
                    <span className='f-700 form-register__label'>Attach Cancelled Cheque Here* : </span>
                    {chequeUploadProg && <ProgressBar id="progress-B" now={chequeUploadProg} label={`${chequeUploadProg}%`} />}
                    {/* {panUploadProg && <ProgressBar id="progress-B" now={panUploadProg} label={`${panUploadProg}%`} />} */}
                    <input type="file" className='py-1 form-regiser__input-file' id="chequeInput" accept='.png, .jpg, .jpeg,.pdf' onChange={(e) => uploadCheque(e)}></input>

                    {/* </div> */}

                </div>


                {/* Mobile no enter */}
                {mobileState === "mobile" && <div className='form-register__theme-shed1 p-2 mt-2 '>
                    <span className='f-700 form-register__label'>Phone<span className='  text-danger'>*</span>:</span><br></br>

                    +91 <input type='number' className='theme-line corner py-1 w-25' onInput={(e) => e.target.value = e.target.value.slice(0, 10)} value={mobile} onChange={(e) => setmobile(e.target.value)} onWheel={(e) => e.target.blur()}>
                    </input>
                    <button className='bg-theme text-white b-n mx-2 px-3  py-1 corner fs-15 ' onClick={() => sendOtp("mobile")}>Verify</button>
                </div>}


                {/* Mobile no otp */}
                {mobileState === "mobileOtp" && <>
                    <div className='form-register__theme-shed1 p-2 mt-2 '>
                        <span className='f-700 '>Phone :</span>
                        <br></br>
                        <span className='fs-15 me-5'>
                            <b>+91</b> {mobile}</span>
                        <span className='theme-col fs-14 mx-4 px-3 f-700'><i className='fa fa-edit' onClick={() => editmobile()}></i> Edit</span>
                        <p className='theme-col fs-10 '>OTP has been sent to your number</p>
                        <form className='d-flex text-center '>    <span className='f-700 '>Enter OTP :</span>
                            <input type='number' className='in-otp form-control-val' value={first} autofocus="" onChange={(e) => handleInput(e.target.value, 0)} onKeyUp={(e) => inputotp(e, 0)} onWheel={(e) => e.target.blur()}></input>
                            <input type='number' className='in-otp form-control-val' value={second} onChange={(e) => handleInput(e.target.value, 1)} disabled onKeyUp={(e) => inputotp(e, 1)} onWheel={(e) => e.target.blur()}></input>
                            <input type='number' className='in-otp form-control-val' value={third} onChange={(e) => handleInput(e.target.value, 2)} disabled onKeyUp={(e) => inputotp(e, 2)} onWheel={(e) => e.target.blur()}></input>
                            <input type='number' className='in-otp form-control-val' value={fourth} onChange={(e) => handleInput(e.target.value, 3)} disabled onKeyUp={(e) => inputotp(e, 3)} onWheel={(e) => e.target.blur()}></input>
                        </form>
                        <div className='text-center'><button className='text-white  py-1 b-n corner px-4 mt-2 bg-theme text-center' onClick={() => verifyOtp()}>Verify</button></div>
                        <div className='text-center' id="OtpTimer"></div>
                        <div className='text-center' style={{ "display": resendOtpDiv }}><button className='v-t-f' onClick={() => sendOtp("mobile", 2)}>Resend Otp</button></div>
                    </div>
                </>
                }

                {/* Mobile verified */}
                {mobileState === "verified" && <div className='form-register__theme-shed1 p-2 mt-2 '>
                    <span className='f-700 '>Phone :</span><br></br>
                    <span className='fs-15'><b>+91</b> {mobile}</span><img src='/shield.png' className='ms-3'></img> <span className='theme-col fs-13'>verified</span>
                </div>}




                {/* Email input */}


                {/* Email verified */}

                {emailState === "email" && <div className='form-register__theme-shed1 p-2 mt-2 '>
                    <span className='f-700 form-register__label'>Email<span className='  text-danger'>*</span>:</span><br></br>
                    <input type='email' className=' w-30 theme-line corner py-1' value={email} onChange={(e) => setemail(e.target.value)}></input>
                    <button className='bg-theme text-white b-n px-3 py-1 corner fs-15  mx-2' onClick={() => sendOtp("mail")}>Verify</button>
                </div>
                }


                {/* Verify email */}

                {emailState === "emailOtp" && <>
                    <div className='form-register__theme-shed1 p-2 mt-2 '>
                        <span className='f-700 '>Email :</span>
                        <br></br>
                        <span className='fs-15 me-5'>
                            {email}</span>
                        <span className='theme-col fs-14 mx-4 px-3 f-700' onClick={() => editmail()}><i className='fa fa-edit'></i> Edit</span>
                        <p className='theme-col fs-10 '>OTP has been sent to your email id</p>
                        <form className='d-flex text-center '>    <span className='f-700 '>Enter OTP :</span>
                            <input type='number' className='in-otp form-control-mail' value={firstmail} autofocus="" onChange={(e) => handleInputMail(e.target.value, 0)} onKeyUp={(e) => inputotmail(e, 0)} onWheel={(e) => e.target.blur()}></input>
                            <input type='number' className='in-otp form-control-mail' value={secondmail} onChange={(e) => handleInputMail(e.target.value, 1)} disabled onKeyUp={(e) => inputotmail(e, 1)} onWheel={(e) => e.target.blur()}></input>
                            <input type='number' className='in-otp form-control-mail' value={thirdmail} onChange={(e) => handleInputMail(e.target.value, 2)} disabled onKeyUp={(e) => inputotmail(e, 2)} onWheel={(e) => e.target.blur()}></input>
                            <input type='number' className='in-otp form-control-mail' value={fourthmail} onChange={(e) => handleInputMail(e.target.value, 3)} disabled onKeyUp={(e) => inputotmail(e, 3)} onWheel={(e) => e.target.blur()}></input>
                        </form>
                        <div className='text-center'><button className='text-white  py-1 b-n corner px-4 mt-2 bg-theme text-center' onClick={() => verifyMailOtp()}>Verify</button></div>
                        <div className='text-center' id="OtpTimerMail"></div>
                        <div className='text-center' style={{ "display": resendOtpDivMail }}><button className='v-t-f' onClick={() => sendOtp("email", 2)}>Resend Otp</button></div>
                    </div>
                </>
                }

                {emailState === "email verified" && <div className='form-register__theme-shed1 p-2 mt-2 '>
                    <span className='f-700 '>Email :</span><br></br>
                    <span className='fs-15'> {email}</span><img src='/shield.png' className='ms-3'></img> <span className='theme-col fs-13'>verified</span>
                </div>
                }


                {/* TAN no */}
                <div className='form-register__theme-shed1 p-2 mt-2 d-flex'>
                    <div className=' p-2 mt-1 '>

                        <span className='f-700 form-register__label'>TAN No :</span><br></br>
                        <input type='text' maxLength="10" className='w-100 theme-line corner py-1' value={tanNo} onChange={(e) => setTanNo(e.target.value)}></input>

                    </div>
                    <div className=' p-2 mt-1 '>
                        <span className='f-700 form-register__label'>Attach TAN No. Document :</span><br></br>
                        {tanUploadProg && <ProgressBar id="progress-B" now={tanUploadProg} label={`${tanUploadProg}%`} />}
                        <input type="file" className='py-1 py-1 form-regiser__input-file' accept='.png, .jpg, .jpeg,.pdf' onChange={(e) => uploadTan(e)} id="tanfileinput"></input>
                        {showtanFileRemove ? <button className='v-t-f' onClick={() => removeFile("TAN")}>Remove File</button> : <></>}

                    </div>
                </div>



                {/* PAN no */}
                <div className='form-register__theme-shed1 p-2 mt-2 d-flex'>
                    <div className=' p-2 mt-1 '>
                        <span className='f-700 form-register__label'>PAN No<span className='  text-danger'>*</span>:</span><br></br>
                        <input type='text' maxLength="10" className=' theme-line corner  py-1' value={panNo} onChange={(e) => setPanNo(e.target.value)}></input>
                    </div>
                    <div className=' p-2 mt-1 '>
                        <span className='f-700 form-register__label'>Attach PAN No. Document<span className='  text-danger'>*</span>:</span><br></br>
                        {panUploadProg && <ProgressBar id="progress-B" now={panUploadProg} label={`${panUploadProg}%`} />}
                        <input type="file" className='py-1 py-1 form-regiser__input-file' accept='.png, .jpg, .jpeg,.pdf' onChange={(e) => uploadPan(e)} id="panInput"></input>
                        <br></br>
                    </div>
                </div>

                <div className=' p-2 mt-2 '>
                    <span className='f-700 form-register__label' >Attach Store Photo<span className='  text-danger'>*</span>:</span><span className='gry fs-13'>(maximum 2 photos)</span>
                    {imgprogress && <ProgressBar id="progress-B" now={imgprogress} label={`${imgprogress}%`} />}

                    <div role="status" id="loader-Img-upload">

                        {urlListshow === true ? urlList.map((item, index) => {
                            return (
                                <span className='p-r'
                                ><img src={"https://s3.toolsvilla.com/mob/products/" + item} key={index} height="65" width="65" className='add-upload-desk'></img>
                                    <span className='cross' onClick={() => deleteImg(index)}>x</span></span>
                            )
                        }) : <></>}







                        <label for="uploadFile1" id="register-form__uploadIcon">

                            <img src='/add-plus.png' className=' upload-img1'></img>
                            <br></br><span className="gry fs-10 mx-3 ">(upload image)</span>
                        </label>
                        {urlList.length === 2 ? <input type="file" disabled id="uploadFile1" class="uploadFile w-20" multiple accept="image/*" /> :
                            urlList.length === 1 ? <input type="file" id="uploadFile1" class="uploadFile w-20" accept="image/*" onChange={(e) => showImage(e)} /> :
                                <input type="file" id="uploadFile1" class="uploadFile w-20" multiple accept="image/*" onChange={(e) => showImage(e)} />}


                    </div>
                </div>
                <div className=' p-2 mt-1 '>
                    <span className='f-700 '>Attach GST Cerificate<span className='  text-danger'>*</span>:</span><br></br>
                    {gstUploadProg && <ProgressBar id="progress-B" now={gstUploadProg} label={`${gstUploadProg}%`} />}
                    <input type="file" className="py-1 form-regiser__input-file" accept='image/*,.pdf' onChange={(e) => uploadGst(e)} id="gstInput"></input>
                    <br></br>
                    {/* <button className='bg-theme b-n text-white corner fs-16 py-1 px-3 mt-2 f-500 '>
                        Upload Certificate
                    </button> */}
                </div>

                <div className='text-center mb-2'><button className='s-mit mt-3' onClick={() => registerSeller()}>Submit</button></div>

                {/* Modal for mobile no already registered */}
                <Modal
                    show={modalShow}
                    onHide={() => setModalShow(false)}
                    size="sm"
                    aria-labelledby="contained-modal-title-vcenter"
                    centered
                >
                    <Modal.Header closeButton>
                    </Modal.Header>
                    <Modal.Body className='mb-3'>
                        <h5>Mobile number already registered</h5>
                        <p className='fs-14'>You can directly login from your mobile number</p>
                        <p className='text-center m-1 mt-2'>
                            <a href={"/login-icon/" + mobile}> <Button size="sm">Go to login page</Button> </a>
                        </p>
                    </Modal.Body>
                </Modal>
            </Container>

        </div>
    )
}

export default Register2